import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";
import { Provider } from "react-redux";
import AfterLoginContainer from "./AfterLoginContainer";
import Login from "../routes/Login";
import ConfirmPasswordReset from "../routes/Login/ConfirmResetPassword";
import VF1Login from "../routes/VisitForm1/Login";
import VF1Wizard from "../routes/VisitForm1/Wizard";
import { vf1Logout } from "../store/visitForm1";
import VF2Login from "../routes/VisitForm2/Login";
import VF2Wizard from "../routes/VisitForm2/Wizard";
import { vf2Logout } from "../store/visitForm2";
import AMA from "../routes/RoomOverview/components/RoomOverview";
import { ThemeProvider } from "@mui/material";
import { theme } from "../theme/";
import FeedbackForm from "../routes/FeedbackForm";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { RECAPTCHA_SITE_KEY } from "../utils";
const { URL_PREFIX, feedbackForm } = window;


// import '../styles/core.scss';

class AppContainer extends Component {
  async componentWillMount() {
    const { user } = this.props.store.getState();
    if(feedbackForm === true) return;
    if (user.info !== null && user.expiredAt < new Date().getTime()) {
      if (window.location.pathname === `${URL_PREFIX}/logout`) return;
      window.location = `${URL_PREFIX}/logout`;
    }
  }

  shouldComponentUpdate() {
    return false;
  }

  render() {
    // If feedbackForm is true, only show feedback route and use it as root
    if (feedbackForm === true) {
      return (
        <ThemeProvider theme={theme}>
          <Provider store={this.props.store}>
            <GoogleReCaptchaProvider reCaptchaKey={RECAPTCHA_SITE_KEY}>
              <Router>
                <Switch>
                  <Route path={`${URL_PREFIX}/`} component={FeedbackForm} exact />
                  <Route path={`${URL_PREFIX}/:guestId`} component={FeedbackForm} exact />
                  <Route render={() => <Redirect to={`${URL_PREFIX}/`} />} />
                </Switch>
              </Router>
            </GoogleReCaptchaProvider>
          </Provider>
        </ThemeProvider>
      );
    }
    
    // Default routing for normal application flow
    return (
      <ThemeProvider theme={theme}>
        <Provider store={this.props.store}>
          <Router>
            <Switch>
              <Route path={`${URL_PREFIX}/login`} component={Login} />
              <Route path={`${URL_PREFIX}/`} component={Login} exact />
              <Route path={`${URL_PREFIX}/feedback/:guestId`} component={FeedbackForm} exact />

              <Route
                path={`${URL_PREFIX}/auth/confirm-password-reset/:linkId`}
                component={ConfirmPasswordReset}
                exact
              />
              <Route
                path={`${URL_PREFIX}/app/`}
                component={AfterLoginContainer}
              />
              <Route path={`${URL_PREFIX}/vf1`} component={VF1Login} exact />
              <Route path={`${URL_PREFIX}/vf1/wizard/`} component={VF1Wizard} />
              <Route path={`${URL_PREFIX}/availability/`} component={AMA} />
              <Route
                path={`${URL_PREFIX}/vf1/logout`}
                exact
                render={() => {
                  this.props.store.dispatch({ type: vf1Logout });
                  setTimeout(() => {
                    window.location = `${URL_PREFIX}/vf1`;
                  }, 100);
                }}
              />
              <Route path={`${URL_PREFIX}/vf2`} component={VF2Login} exact />
              <Route path={`${URL_PREFIX}/vf2/wizard/`} component={VF2Wizard} />
              <Route
                path={`${URL_PREFIX}/vf2/logout`}
                exact
                render={() => {
                  this.props.store.dispatch({ type: vf2Logout });
                  setTimeout(() => {
                    window.location = `${URL_PREFIX}/vf2`;
                  }, 100);
                }}
              />
              <Route
                path={`${URL_PREFIX}/logout`}
                render={() => {
                  this.props.store.dispatch({ type: "LOGOUT" });
                  setTimeout(() => {
                    window.location = URL_PREFIX;
                  }, 500);
                }}
              />
              <Route render={() => <Redirect to={`${URL_PREFIX}/`} />} />
            </Switch>
          </Router>
        </Provider>
      </ThemeProvider>
    );
  }
}

AppContainer.propTypes = {
  store: PropTypes.object.isRequired,
};

export default AppContainer;
